import {
  USER_REQUEST,
  USER_CPTY_REQUEST,
  USER_FREE_DATA,
  USER_SEND_FEEDBACK,
  USER_SEND_ANKETA,
  USER_CONT_ADD,
  USER_CONT_UPDATE,
  USER_CONT_DELETE,
  USER_CONT_MAIN,
  USER_GET_ACCEPTORS,
  USER_CLEAR_ACCEPTORS,
  USER_GET_OKPD,
  USER_GET_USERS

} from '../actions/user'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR, UI_SET_MODULES } from '../actions/ui'
import { AUTH_LOGOUT } from '../actions/auth'
import { ORG_SET_USER_CONTACT_MAIN } from '../actions/org'

import axios from 'axios'

const state = {
  profile: {},
  acceptorsList: [],
  okpd: []
}

const getters = {
  getProfile: state => {
    console.log('Requested getter for user profile ', state.profile)
    return state.profile
  },
  getOKPD: state => {
    return state.okpd
  },
  getAcceptorsList: state => state.acceptorsList
}

const actions = {
  [USER_GET_ACCEPTORS]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'USER_GET_ACCEPTORS', topic: 'Запрос пользователей для социальной активности', error: null })
      console.log('USER_GET_ACCEPTORS action called')
      commit(USER_CLEAR_ACCEPTORS)
      axios({ url: '/api/user/getLikeAcceptors.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'USER_GET_ACCEPTORS' })
            commit(USER_GET_ACCEPTORS, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'USER_GET_ACCEPTORS', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'USER_GET_ACCEPTORS', result: err })
          reject(err)
        })
    }),
  [USER_GET_USERS]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'USER_GET_USERS', topic: 'Запрос пользователей организации', error: null })
      console.log('USER_GET_USERS action called')
      commit(USER_CLEAR_ACCEPTORS)
      axios({ url: '/api/org/admin/getOrgUsers.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'USER_GET_USERS' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'USER_GET_USERS', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'USER_GET_USERS', result: err })
          reject(err)
        })
    }),
  [USER_REQUEST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'USER_REQUEST', topic: 'Запрос профиля пользователя', error: null })
      // console.log('USER_REQUEST action called')
      axios({ url: '/api/user/getprofile.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'USER_REQUEST' })
            dispatch(UI_SET_MODULES, resp.data.modules)
            commit(USER_REQUEST, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'USER_REQUEST', result: resp.data.error_text })
            reject(resp.data.error_text)
            dispatch(AUTH_LOGOUT)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'USER_REQUEST', result: err })
          dispatch(AUTH_LOGOUT)
          reject(err)
        })
    }),
  [USER_CPTY_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'USER_CPTY_REQUEST', topic: 'Запрос профиля пользователя контрагента', error: null })
      console.log('USER_CPTY_REQUEST action called')
      axios({ url: '/api/user/getprofile.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'USER_CPTY_REQUEST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'USER_CPTY_REQUEST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'USER_CPTY_REQUEST', result: err })
          reject(err)
        })
    }),
  [USER_FREE_DATA]: ({ commit }) =>
    new Promise((resolve) => {
      console.log('USER_FREE_DATA action called')
      commit(USER_FREE_DATA)
      resolve('success')
    }),
  [USER_CONT_ADD]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'USER_CONT_ADD', topic: 'Добавление контакта', error: null })
      console.log('USER_CONT_ADD action called ', params)
      axios({ url: '/api/org/admin/addUserContact.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const newContact = resp.data.data
            dispatch(UI_SUCCESS, { action: 'USER_CONT_ADD' })
            commit(USER_CONT_ADD, newContact)
            resolve(newContact)
          } else {
            dispatch(UI_ERROR, { action: 'USER_CONT_ADD', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'USER_CONT_ADD', result: err })
          reject(new Error(err))
        })
    }),
  [USER_CONT_UPDATE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'USER_CONT_UPDATE', topic: 'Обновление контакта', error: null })
      console.log('USER_CONT_UPDATE action called ', params)
      axios({ url: '/api/org/admin/updUserContact.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const newContact = resp.data.data
            dispatch(UI_SUCCESS, { action: 'USER_CONT_UPDATE' })
            commit(USER_CONT_UPDATE, newContact)
            resolve(newContact)
          } else {
            dispatch(UI_ERROR, { action: 'USER_CONT_UPDATE', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'USER_CONT_UPDATE', result: err })
          reject(new Error(err))
        })
    }),
  [USER_CONT_DELETE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'USER_CONT_DELETE', topic: 'Удаление контакта', error: null })
      console.log('USER_CONT_DELETE action called ', params)
      axios({ url: '/api/org/admin/delUserContact.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const respContact = resp.data.data
            dispatch(UI_SUCCESS, { action: 'USER_CONT_DELETE' })
            commit(USER_CONT_DELETE, respContact)
            resolve(respContact)
          } else {
            dispatch(UI_ERROR, { action: 'USER_CONT_DELETE', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'USER_CONT_DELETE', result: err })
          reject(new Error(err))
        })
    }),
  [USER_CONT_MAIN]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'USER_CONT_MAIN', topic: 'Удаление контакта', error: null })
      console.log('USER_CONT_MAIN action called ', params)
      axios({ url: '/api/org/admin/setUserContactMain.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const respContact = resp.data.data
            dispatch(UI_SUCCESS, { action: 'USER_CONT_MAIN' })
            commit(USER_CONT_MAIN, respContact)
            commit(ORG_SET_USER_CONTACT_MAIN, respContact)
            resolve(respContact)
          } else {
            dispatch(UI_ERROR, { action: 'USER_CONT_MAIN', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'USER_CONT_MAIN', result: err })
          reject(new Error(err))
        })
    }),
  [USER_SEND_FEEDBACK]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'USER_SEND_FEEDBACK', topic: 'Отправка сообщения обратной связи', error: null })
      console.log('USER_SEND_FEEDBACK action called ', params)
      axios({ url: '/api/user/sendUserFeedback.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const sendResult = resp.data.data
            dispatch(UI_SUCCESS, { action: 'USER_SEND_FEEDBACK' })
            commit(USER_SEND_FEEDBACK, sendResult)
            resolve(sendResult)
          } else {
            dispatch(UI_ERROR, { action: 'USER_SEND_FEEDBACK', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'USER_SEND_FEEDBACK', result: err })
          reject(new Error(err))
        })
    }),
  [USER_SEND_ANKETA]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'USER_SEND_ANKETA', topic: 'Отправка анкеты', error: null })
      console.log('USER_SEND_ANKETA action called ', params)
      axios({ url: '/api/anketa/registerCV.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const sendResult = resp.data.data
            commit(USER_SEND_FEEDBACK, sendResult)
            dispatch(UI_SUCCESS, { action: 'USER_SEND_ANKETA' })
            resolve(sendResult)
          } else {
            dispatch(UI_ERROR, { action: 'USER_SEND_FEEDBACK', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'USER_SEND_FEEDBACK', result: err })
          reject(new Error(err))
        })
    }),
  [USER_GET_OKPD]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'USER_GET_OKPD', topic: 'Запрос справочника ОКПД2', error: null })
      console.log('USER_GET_OKPD action called ', params)
      axios({ url: '/api/user/getOKPDTree.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            const getResult = resp.data.data
            commit(USER_GET_OKPD, getResult)
            dispatch(UI_SUCCESS, { action: 'USER_GET_OKPD' })
            resolve(getResult)
          } else {
            dispatch(UI_ERROR, { action: 'USER_GET_OKPD', result: resp.data.error_text })
            commit(USER_GET_OKPD, [])
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'USER_GET_OKPD', result: err })
          commit(USER_GET_OKPD, [])
          reject(new Error(err))
        })
    })
}

const mutations = {
  [USER_REQUEST]: (state, resp) => {
    console.log('USER_REQUEST mutation called')
    state.profile = resp
  },
  [USER_FREE_DATA]: state => {
    state.profile = {}
    state.okpd.splice(0, state.okpd.length)
  },
  [USER_CONT_ADD]: (state, resp) => {
    console.log('USER_CONT_ADD mutation called, payload', resp)
  },
  [USER_CONT_UPDATE]: (state, resp) => {
    console.log('USER_CONT_UPDATE mutation called, payload', resp)
  },
  [USER_CONT_DELETE]: (state, resp) => {
    console.log('USER_CONT_DELETE mutation called, payload', resp)
  },
  [USER_CONT_MAIN]: (state, resp) => {
    console.log('USER_CONT_MAIN mutation called, payload', resp)
  },
  [USER_GET_ACCEPTORS]: (state, resp) => {
    console.log('USER_GET_ACCEPTORS mutation called')
    state.acceptorsList = resp
  },
  [USER_CLEAR_ACCEPTORS]: (state) => {
    console.log('USER_CLEAR_ACCEPTORS mutation called')
    state.acceptorsList = []
  },
  [USER_SEND_FEEDBACK]: (state) => {
    console.log('USER_SEND_FEEDBACK mutation called with current state ', state)
  },
  [USER_GET_OKPD]: (state, resp) => {
    console.log('USER_GET_OKPD mutation called')
    state.okpd.splice(0, state.okpd.length, ...resp)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
